var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvgOrderValue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F4ECFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_10627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 11.3333L12 14V23.3333C12 23.687 12.1405 24.0261 12.3905 24.2762C12.6406 24.5262 12.9797 24.6667 13.3333 24.6667H22.6667C23.0203 24.6667 23.3594 24.5262 23.6095 24.2762C23.8595 24.0261 24 23.687 24 23.3333V14L22 11.3333H14Z",
    stroke: "#883DCF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14H24",
    stroke: "#883DCF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 16.6667C20.6667 17.3739 20.3858 18.0522 19.8857 18.5523C19.3856 19.0524 18.7073 19.3333 18 19.3333C17.2928 19.3333 16.6145 19.0524 16.1144 18.5523C15.6143 18.0522 15.3334 17.3739 15.3334 16.6667",
    stroke: "#883DCF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3701 10.2003C16.0524 10.5711 15.946 11.0352 15.946 11.3867V14.3923C15.946 14.4655 15.9163 14.5318 15.8687 14.5801C15.8203 14.6278 15.754 14.6575 15.6808 14.6575C15.598 14.6575 15.5248 14.6195 15.4757 14.5601C15.4384 14.5145 15.4156 14.4558 15.4156 14.3923V11.3867C15.4156 10.9427 15.5475 10.346 15.9674 9.85496C16.3949 9.35566 17.0931 9 18.156 9C19.2195 9 19.917 9.35566 20.3452 9.85496C20.7651 10.346 20.8963 10.9427 20.8963 11.3867V14.3923C20.8963 14.5387 20.7776 14.6575 20.6312 14.6575C20.4847 14.6575 20.366 14.5387 20.366 14.3923V11.3867C20.366 11.0352 20.2596 10.5711 19.9419 10.2003C19.6319 9.83771 19.0918 9.53039 18.1559 9.53039C17.2202 9.53039 16.6809 9.83771 16.3701 10.2003ZM20.0124 12.2707H16.2997V14.3923C16.2997 14.7341 16.0228 15.0111 15.6809 15.0111C15.3391 15.0111 15.0621 14.7341 15.0621 14.3923V12.2707H13.3846C13.2009 12.2707 13.0476 12.4109 13.0324 12.5939L12.0014 24.616C11.9834 24.8225 12.1464 25 12.3536 25H23.9895C24.1967 25 24.3597 24.8218 24.3417 24.6153L23.2761 12.5932C23.2596 12.4109 23.1069 12.2707 22.9239 12.2707H21.2499V14.3923C21.2499 14.7341 20.973 15.0111 20.6311 15.0111C20.2893 15.0111 20.0123 14.7341 20.0123 14.3923L20.0124 12.2707Z",
    fill: "#883DCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_10627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgOrderValue);
export default __webpack_public_path__ + "static/media/avgOrderValue.4541ef0e2c0991759082221a675db8f0.svg";
export { ForwardRef as ReactComponent };